/** Sentinel value for the inbox Sender ID filter when all senders are selected. */
export const ALL_SENDER_IDS_VALUE = '__ALL__';
